import * as React from 'react';
import type { SvgProps } from 'react-native-svg';
import Svg, { Path } from 'react-native-svg';

import colors from '../colors';

export const Share = ({
  color = colors.neutral[500],
  fill,
  ...props
}: SvgProps) => (
  <Svg width={9} height={12} viewBox="0 0 8.91 12" fill="none" {...props}>
    <Path
      d="M2.69 2.259c-.179 0-.307-.129-.307-.304 0-.089.035-.159.101-.225L4.148.113C4.233.027 4.311 0 4.397 0c.085 0 .163.027.248.113l1.664 1.617c.062.066.101.136.101.225 0 .175-.136.304-.315.304-.081 0-.171-.035-.233-.105l-.844-.886L4.397.614l-.622.653L2.927 2.154c-.062.07-.155.105-.237.105ZM4.397 7.234c-.183 0-.342-.151-.342-.33V1.687l.05-1.244c.008-.16.133-.291.292-.291.16 0 .284.132.292.291l.05 1.244V6.904c0 .179-.16.33-.342.33ZM2.072 11.118h4.649c1.333 0 2.072-.743 2.072-2.072V5.209c0-1.33-.739-2.068-2.072-2.068H2.072C.739 3.141 0 3.88 0 5.209v3.837c0 1.329.739 2.072 2.072 2.072Z"
      fill={fill || color}
    />
  </Svg>
);
